import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ToDo } from '../data/todo/domain/todo';

@Injectable()
export class TasksService {
  public addedToDoSubject = new Subject<unknown>();
  public editToDoSubject = new Subject<ToDo>();

  openAddToDoModal(target: unknown) {
    this.addedToDoSubject.next(target);
  }

  openEditToDoModal(todo: ToDo) {
    this.editToDoSubject.next(todo);
  }
}
